// Lage & Karte: Links für Google Maps (Embed, Route, Suche) und OpenStreetMap.
// Der Embed-Schlüssel ist derselbe, den die bisherige Objektübersicht nutzt
// (Embed-Schlüssel sind öffentlich und per Referrer beschränkt).

export const GOOGLE_MAPS_EMBED_KEY = 'AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8';

export type Kartentyp = 'roadmap' | 'satellite';

export function kartenEinbettung(adresse: string, zoom: number, typ: Kartentyp): string {
  const q = encodeURIComponent(adresse);
  return `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_EMBED_KEY}&q=${q}&zoom=${zoom}&maptype=${typ}`;
}

export function routeLink(adresse: string): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(adresse)}`;
}

export function googleMapsLink(adresse: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(adresse)}`;
}

export function osmLink(adresse: string): string {
  return `https://www.openstreetmap.org/search?query=${encodeURIComponent(adresse)}`;
}
